import { Card, Text } from "@overmap-ai/blocks"
import { type FormSubmission, type Stored } from "@overmap-ai/common"
import { selectFormById, selectUserById } from "@overmap-ai/core"
import { gray } from "@radix-ui/colors"
import { memo } from "react"

import { FormSubmissionTimelineItemType } from "../../enums/forms"
import { formSubmissionTimelineItemTypeData } from "../../mappings/forms"
import { modelIconMapping } from "../../mappings/icons"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { LuIconWithWrapper } from "../Icons/LuIconWithWrapper"
import { FormSubmissionIndexLabel } from "../IndexLabels/FormSubmissionIndexLabel"
import { TimelineIconRail } from "../TimelineIconRail/TimelineIconRail"
import type { FormSubmissionTimelineSize } from "./typings"

interface FormSubmissionCreatedTimelineItemProps {
	formSubmission: Stored<FormSubmission>
	size: FormSubmissionTimelineSize
}

export const FormSubmissionCreatedTimelineItem = memo<FormSubmissionCreatedTimelineItemProps>((props) => {
	const { formSubmission, size } = props

	const createdBy = useAppSelector(selectUserById(formSubmission.created_by ?? -1))
	const form = useAppSelector(selectFormById(formSubmission.form))!
	const { icon } = formSubmissionTimelineItemTypeData[FormSubmissionTimelineItemType.CREATED]

	return (
		<div className="flex h-max w-full gap-4">
			<TimelineIconRail icon={icon} size={size} />
			<Card className="flex min-w-0 grow flex-col gap-1" size={size}>
				<Text size={size} accentColor="base">
					<Text highContrast>{getUserDisplayLabel(createdBy)}</Text>
					&nbsp;submitted form&nbsp;
					<Text accentColor="base">&nbsp;&#8226;&nbsp;{formatCompactDate(formSubmission.submitted_at)}</Text>
				</Text>
				<Text accentColor="base" className="min-w-0 truncate" size={size}>
					<LuIconWithWrapper
						icon={modelIconMapping.form}
						color={gray.gray9}
						background
						className="align-sub"
					/>
					&nbsp;
					<FormSubmissionIndexLabel formSubmissionId={formSubmission.uuid} highContrast />
					&nbsp;
					<Text accentColor="base">{form.name}</Text>
				</Text>
			</Card>
		</div>
	)
})
FormSubmissionCreatedTimelineItem.displayName = "FormSubmissionCreatedTimelineItem"
